import { Modal } from 'ant-design-vue';

/**
 * 消息确认框
 * 调用方式-参数调用，OK的loading会等待promiseMethod执行后关闭
 * @param content 主题内容
 * @param promiseMethod ok时执行的异步函数
 * @param catchMethod promiseMethod异常回调
 * @param opt Modal-confirm 配置项
 * @returns void
 */
export const promiseConfirm = (
  content: string,
  promiseMethod: () => Promise<void>,
  opt = {
    okText: '确定',
    cancelText: '取消',
  },
  catchMethod?: () => void,
) => {
  const modal = Modal.confirm({
    ...opt,
    content,
    onOk: () => new Promise<void>((resolve, reject) => {
      promiseMethod().then(() => {
        resolve();
      }).catch(() => {
        reject();
        modal.destroy();
        if (catchMethod) catchMethod();
      });
    }),
  });
};

export const self = '消息提示类型';
